import React from "react";
import { Routes, Route } from "react-router-dom";

//css
import "./style/css/style.css";

//pages
import AppNav from "./header/AppNav.js";
import Dashboard from "./pages/Dashboard.js";
import Taluk from "./pages/master-data/taluk/Taluk.js";
import PHCs from "./pages/master-data/phc/PHCs.js";
import AshaBlock from "./pages/master-data/asha-block/AshaBlock.js";
import Hospitals from "./pages/hospital/Hospitals.js";
import SSMembers from "./pages/SSMembers/SSMembers";
import Camp from "./pages/sscamp/Camp";
import SstTeam from "./pages/sst-team/SstTeam";
import AddSstTeam from "./pages/sst-team/AddSstTeam";
import Asha from "./pages/asha/Asha";
import AshaAbstractReport from "./pages/asha/AshaAbstractReport";
import Login from "./pages/components/Login";
import Users from "./pages/users/Users";
import PatientsHistory from "./pages/patients/patients-history/PatientsHistory";
import PatientsHistoryDetails from "./pages/patients/patients-history/PatientsHistoryDetails";
import EditPatientsHistory from "./pages/patients/patients-history/EditPatientsHistory";
import PatientDetailsPage from "./pages/patients/patients-history/PatientDetailsPage";
import UpdatePatientPage from "./pages/patients/patients-history/UpdatePatientPage";
import FollowUpPlaces from "./pages/master-data/followup-place/FollowUpPlaces.js";
import Reports from "./pages/reports/Reports.js";
import SecondaryScreeningReport from "./pages/reports/SecondaryScreeningReport.js";
import ForgotPassword from "./pages/components/ForgotPassword";
import ChangePassword from "./pages/components/ChangePassword";

function App() {
  return (
    <>
      {/* <AppNav /> */}
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/taluk" element={<Taluk />} />
        <Route path="/phc" element={<PHCs />} />
        <Route path="/phc" element={<PHCs />} />
        <Route path="/asha-block" element={<AshaBlock />} />
        <Route path="/hospitals" element={<Hospitals />} />
        <Route path="/secondary-screening-members" element={<SSMembers />} />
         <Route path="/secondary-screening-camp" element={<Camp />} />
        <Route path="/secondary-screening-team" element={<SstTeam />} />
        <Route path="/asha" element={<Asha />} />
        <Route path="/asha-abstract-report" element={<AshaAbstractReport />} />
        <Route path="/users" element={<Users />} />
        <Route path="/patients-history" element={<PatientsHistory />} />  
        <Route path="/patient-details/:patientId" element={<PatientDetailsPage />} />
        <Route path="/update-patient/:patientId" element={<UpdatePatientPage />} />
        <Route path="/followup-place" element={<FollowUpPlaces />} />
        <Route
          path="/patients-history-details"
          element={<PatientsHistoryDetails />}
        />
        <Route path="/edit-patient-details" element={<EditPatientsHistory />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/secondary-screening-report" element={<SecondaryScreeningReport />} />
        <Route path="/forgotPassword" element={<ForgotPassword />} />
        <Route path="/changePassword" element={<ChangePassword />} />
      </Routes>
    </>
  );
}

export default App;
